var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('alert-message-modal'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('div',{staticClass:"content content-narrow"},[_c('div',{staticClass:"row"},[_c('strain'),_vm._v(" "),_c('room'),_vm._v(" "),_c('plant-batch'),_vm._v(" "),_c('item'),_vm._v(" "),_c('package')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42556ffe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/components/Dashboard.vue
// module id = null
// module chunks = 